<template>
<div>
    <CondicionesReportTable default-to-primera :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable" @downloadExcel="sendExcel">
        <span slot="after-filters">
          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="sendExcel" flat>
              <v-icon color="primary">far fa-file-excel</v-icon>
            </v-btn>
            <span>Descargar XLS</span>
          </v-tooltip>
        </span>
    </CondicionesReportTable>
    <v-snackbar v-model="sendEmailAlert" auto-height color="error">
      <span>En unos minutos recibirá el reporte a su correo electrónico</span>
      <v-btn icon @click="sendEmailAlert = false"><v-icon>close</v-icon></v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import CondicionesReportTable from './CondicionesReportTable'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'

export default {
  mixins: [downloadFileMixin, paginationMixin],
  data () {
    return {
      path: `condiciones/jugadores/list`,
      filterPath: 'filter/condiciones',
      sendEmailAlert: false
    }
  },
  components: {
    CondicionesReportTable
  },
  computed: {
    headers () {
      return [
        { text: 'Club', value: 'club', align: 'left', filterField: true, sortable: false },
        { text: 'Mes', value: 'mes', align: 'left', sortable: false },
        { text: 'Apellido', value: 'playerLastName', align: 'left', sortable: false },
        { text: 'Nombre', value: 'playerFirstName', align: 'left', sortable: false },
        { text: 'DNI', value: 'dni', sortable: false },
        { text: 'Pasaporte', value: 'pasaporte', sortable: false },
        { text: 'Fecha Nacimiento', value: 'birth_day', sortable: false },
        { text: 'Edad', value: 'age', sortable: false },
        { text: 'Concepto', value: 'concepto', align: 'left', sortable: false },
        { text: 'Bruto/Neto', value: 'brutoNeto', align: 'left', sortable: false },
        { text: 'Frecuencia', value: 'frecuencia', align: 'left', sortable: false },
        { text: 'Moneda', value: 'moneda', align: 'left', sortable: false },
        { text: 'Tipo de Cambio', value: 'tipoDeCambio', align: 'left', sortable: false },
        { text: 'Desc. Tipo de Cambio', value: 'tipoDeCambioDescripcion', align: 'left', sortable: false },
        { text: 'Importe', value: 'importeMensual', align: 'left', sortable: false, currencyField: true },
        { text: 'Cuota', value: 'cuota', align: 'left', sortable: false },
        { text: 'Temporada', value: 'temporada', align: 'left', sortable: false }
      ]
    },
    properties () {
      return ['club', 'mes', 'playerLastName', 'playerFirstName', 'dni', 'pasaporte', 'birthDay', 'age', 'concepto', 'brutoNeto', 'frecuencia', 'moneda', 'tipoDeCambio', 'tipoDeCambioDescripcion', 'importeMensual', 'cuota', 'temporada']
    }
  },
  methods: {
    getExcelPath () {
      return 'condiciones/jugadores/xls/delay' + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return 'condiciones_jugadores'
    },
    sendExcel () {
      this.axios
        .get(this.getExcelPath())
        .then((response) => {
          this.sendEmailAlert = true
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    }
  }
}
</script>
